import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import General from './General.js';
import Introduction from './Introduction/Introduction.js';
import Economics from './EconomicsOfCulture/Economics.js';
import BodyOfWork from './BodyOfWork/BodyOfWork.js';
import IntegratedTimeline from './IntegratedTimeline/IntegratedTimeline.js';
import { getLocationData } from '../../services/Location.js';
import MyTabsNested from '../../components/MyTabsNested.js';
import Basic from './Basic.js';
import GeographicalDetails from './Introduction/GeographicalDetails.js';
import ArchitecturalLandmarks from './Introduction/ArchitecturalLandmarks.js';
import OtherLandmarks from './Introduction/OtherLandmarks.js';
import NaturalHeritage from './BodyOfWork/NaturalHeritage.js';
import CulturalLandmarks from './BodyOfWork/CulturalLandmarks.js';
import ECONBasic from './EconomicsOfCulture/Basic.js';
import ITBasic from './IntegratedTimeline/Basic.js';
import { useSelector } from 'react-redux';
import Sections from '../../CommonComponents/Sections.js';
import MyAccordionNested from '../../components/MyAccordionNested.js';
import ManMadeHeritage from './BodyOfWork/ManMadeHeritage/ManMadeHeritage.js';
import ResearchCentre from '../../FunctionalComponents/ResearchCentre/ResearchCentre.js';
import Library from '../../FunctionalComponents/ResearchCentre/Library.js';
import Archive from '../../FunctionalComponents/ResearchCentre/Archive.js';

const EditLocationRecord = () => {

  const { alias } = useParams();
  const [locationTitle, setLocationTitle] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const previewEnabled = useSelector(state => state.preview.isEnabled);

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: General, subTabs: [
        { id: "primary", title: "Primary", Component: Basic },
        { id: "sections", title: "Sections", Component: Sections }
      ]
    },
    {
      id: "introduction", title: "Introduction", Component: Introduction, subTabs: [
        { id: "geographical-details", title: "Geographical Details", Component: GeographicalDetails },
        { id: "architectural-landmarks", title: "Architectural Landmarks", Component: ArchitecturalLandmarks },
        { id: "other-landmarks", title: "Other Landmarks", Component: OtherLandmarks },
      ]
    },
    {
      id:"research-centre", title: "Research Centre", Component: ResearchCentre,
      subTabs: [
        { id: "library", title: "Library", Component: Library },
        { id: "archive", title: "Archive", Component: Archive },
      ]
    },
    {
      id: "body-of-work", title: "Body Of Work", Component: BodyOfWork, subTabs: [
        { id: "man-made-heritage", title: "Man Made Heritage", Component: ManMadeHeritage },
        { id: "natural-heritage", title: "Natural Heritage", Component: NaturalHeritage },
        { id: "cultural-landmark", title: "Cultural Landmarks", Component: CulturalLandmarks },

      ]
    },
    {
      id: "integrated-timeline", title: "Integrated Timeline", Component: IntegratedTimeline, subTabs: [
        { id: "basic", title: "Basic", Component: ITBasic },
      ]
    },
    {
      id: "economics-of-culture", title: "Economics of Culture", Component: Economics, subTabs: [
        { id: "basic", title: "Basic", Component: ECONBasic },
      ]
    },
  ], []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getLocationData(alias, 'general', 'basic');
          if (result && result?.data && result?.data?.length > 0 && result?.data?.[0]?.name) {
            setLocationTitle(result.data[0].name);
          }
        }
      } catch (error) {
        console.error('Error fetching film data:', error);
      }
    };

    getBasicData();
  }, [alias]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(`/location/${alias}/agraphy/${tabs[0].id}/${tabs[0].subTabs[0].id}`, { replace: true });
    }
  }, [location.pathname, alias, navigate, tabs]);

  return (
    <Stack px="1rem" pb={'1rem'} width={"100%"}>
    <Box>
      <Text fontSize={"18px"} pt={2} fontWeight={"600"}>{locationTitle}</Text>
    </Box>
      {previewEnabled ?
        <MyAccordionNested orientation="vertical" list={tabs} urlBasePath="/location" tabSegmentPosition={3} subTabSegmentPosition={4} includeAgraphy /> :
        <MyTabsNested orientation="vertical" list={tabs} urlBasePath="/location" tabSegmentPosition={3} subTabSegmentPosition={4} includeAgraphy />}
    </Stack>
  );
};

export default EditLocationRecord;